import React from 'react';
import {GroupTypeBase, OptionTypeBase} from 'react-select/src/types';
import {Props} from 'react-select';
import 'config/react-select.css'
import {StateManager} from 'react-select/src/stateManager'
import SelectBase from 'react-select/src/Select'

// fixes missing properties
export interface ReactSelect<OptionType extends OptionTypeBase = { label: string; value: string },
	IsMulti extends boolean = false,
	GroupType extends GroupTypeBase<OptionType> = GroupTypeBase<OptionType>,
	T extends SelectBase<OptionType, IsMulti> = SelectBase<OptionType, IsMulti>> extends StateManager<OptionType, IsMulti, GroupType, T> {
	select: T & { inputRef?: HTMLInputElement }
}

export interface ReactSelectProps<OptionType extends OptionTypeBase,
	IsMulti extends boolean = false,
	GroupType extends GroupTypeBase<OptionType> = GroupTypeBase<OptionType>> extends Props<OptionType, IsMulti, GroupType> {
}

export function getReactSelectDefaultProps<OptionType extends OptionTypeBase,
	IsMulti extends boolean = false,
	GroupType extends GroupTypeBase<OptionType> = GroupTypeBase<OptionType>>({styles, ...props}: ReactSelectProps<OptionType, IsMulti, GroupType>): ReactSelectProps<OptionType, IsMulti, GroupType> {
	return {
		menuPortalTarget: document.body, // do not use scrollable content for this portal target. otherwise it would scroll away and/or selected value may be wrong! body is not longer scrolling! #PanelViewWrapContent is scrolling.
		autoFocus: false,
		hideSelectedOptions: false,
		placeholder: "Auswählen...",
		noOptionsMessage: () => "Keine Einträge gefunden",
		loadingMessage: () => "Laden...",
		styles: {
			control: (base, props) => ({
				...base,
				minHeight: undefined, // fixes: height adapts to font-size
			}),
			noOptionsMessage: (base, props) => ({
				...base,
				whiteSpace: 'pre-line',
			}),
			option: (base) => ({
				...base,
				wordBreak: 'break-word',
				fontSize: 14,
			}),
			menuPortal: (base) => ({
				...base,
				zIndex: 2000,
				top: typeof base.top === 'number' ? +base.top - 7 : base.top,
			}),
			menu: (base) => ({
				...base,
				overflow: 'hidden',
				zIndex: 2000,
				boxShadow: '0 4px 16px hsla(0,0%,0%,0.7)',
				width: props.isAze && "max-content" || '100%',
				minWidth: '280px',
			}),
			input: (base, inputProps) => ({
				...base,
				visibility: "visible",
				color: inputProps.isDisabled ? '#363232' : '#000',
				fontSize: 13,
			}),
			dropdownIndicator: base => ({...base, padding: 4}),
			clearIndicator: base => ({...base, padding: 4}),
			groupHeading: (base) => ({
				...base,
				position: 'sticky',
				background: '#ffffff',
				top: -5,
				paddingTop: 5,
				paddingBottom: 5,
			}),
			multiValueLabel: (base) => ({
				...base,
				fontSize: '95%',
			}),
			multiValueRemove: (base) => ({
				...base,
				background: 'inherit',
			}),
			...styles,
		},
		...props,
	}
}